import { TableContainer } from '@material-ui/core';
import styled from 'styled-components';

export const WrapperContainer = styled(TableContainer)`
  height: 100%;

  position: relative;

  @media (max-width: 600px) {
    .MuiTableCell-sizeSmall {
      padding: 4px 20px 4px 10px;
    }
  }
`;

export const TextField = styled.p`
  font-size: 14px;
  font-weight: 700;
`;
